import { ArrowCta } from '@/components/ui/navigation/ctas/ArrowCta';
import { bigCtaBlock, bordersWrapper } from '@mage-ui/styled-system/recipes';

export const BigCtaBlock = ({ data }) => {
  const ctaText = data?.fields?.cta_text?.trim();
  const ctaSlug = data?.fields?.cta_slug?.trim();

  if (!(ctaText && ctaSlug)) {
    return null;
  }

  return (
    <div className={bigCtaBlock()}>
      <div className={bordersWrapper()}>
        <ArrowCta
          data={{
            cta_slug: ctaSlug || '#',
            cta_text: ctaText,
          }}
        />
      </div>
    </div>
  );
};
